module.exports = __webpack_public_path__ + "8f16b81dd400112540ad7bb9a0c65e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/fonts/ui-grid.svg
// module id = 10
// module chunks = 0